import "./checkBalancePage.css";
import { useState, useEffect } from "react";
import { JsonRpcProvider } from "ethers";
import _ from "lodash";
import BigNumber from "bignumber.js";
import { Box, Container, Stack, Typography } from "@mui/material";
import {
    BoxCustomerID,
    BoxValueCustomerID,
    ContainButtonShort,
    CustomTitle,
} from "../../utils";
import Top from "../../components/top/Top";
import { useHoldersBalance } from "../../hooks/useHolderBalance";
import { useHoldersList } from "../../hooks/useHoldersList";
import { useSearchParams } from "react-router-dom";
import { useTokenName } from "../../hooks/useTokenName";
import { useTokenSymbol } from "../../hooks/useTokenSymbol";

export const CheckBalancePage = () => {
    const [searchParams] = useSearchParams();
    const paramTokenAddress = searchParams.get("tokenAddress");

    const genProvider = new JsonRpcProvider(process.env.REACT_APP_RPC_PROVIDER);
    const [customerId, setCustomerId] = useState("");
    const [amount, setAmount] = useState<any>(null);
    const [isSubmit, setIsSubmit] = useState(false);
    const { onCheckBalanceHolder } = useHoldersBalance();
    const { holderAll, holderListAll } = useHoldersList(genProvider);
    const tokenName = useTokenName(genProvider, paramTokenAddress);
    const tokenSymbol = useTokenSymbol(genProvider, paramTokenAddress);

    const onChangeCustomerId = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAmount(null);
        setIsSubmit(false);
        setCustomerId(event.target.value);
    };

    const handleSubmit = () => {
        if (paramTokenAddress !== null || paramTokenAddress !== undefined || paramTokenAddress !== "") {
            onCheckBalanceHolder(genProvider, customerId, paramTokenAddress)
                .then((resp: any) => {
                    setIsSubmit(true);
                    const customer = holderAll.find((v: { address: any, balance: any }) => v.address === customerId);
                    const amount = new BigNumber(resp).div(new BigNumber(10).pow(18)).toNumber();

                    if (amount > 0) {
                        const amt = new BigNumber(resp).div(new BigNumber(10).pow(18)).toString();
                        const firstIndex = Number(amt.split(".")[0]).toLocaleString();
                        const decimal = amt.split(".")[1];
                        const concat = decimal ? firstIndex + "." + decimal : firstIndex

                        // const amt = new BigNumber(Number(resp)).div(new BigNumber(10).pow(18)).toNumber();
                        setAmount(concat);
                    } else {
                        if (amount === 0 && customer) {
                            const amt = new BigNumber(resp).div(new BigNumber(10).pow(18)).toString();
                            const firstIndex = Number(amt.split(".")[0]).toLocaleString();
                            const decimal = amt.split(".")[1];
                            const concat = decimal ? firstIndex + "." + decimal : firstIndex

                            // const amt = new BigNumber(Number(resp)).div(new BigNumber(10).pow(18)).toNumber();
                            setAmount(concat);
                        }
                    }
                    // }
                }).catch((e: any) => console.error);

        }
    };

    useEffect(() => {
        holderListAll().catch(console.error)
    }, [])

    return (
        <Container sx={{ textAlign: "center" }}>
            <Box display="flex" flexDirection="column">
                <Top
                    title="Check"
                    subTitle={`${tokenSymbol} Token Balance`}
                    description="Check out the total number of tokens in your wallet here"
                />
                <Stack
                    mt="80px"
                    gap={10}
                    alignItems="center"
                    flexWrap="wrap"
                    justifyContent={"center"}
                    alignSelf={"center"}
                >
                    <Box
                        sx={{ display: { xs: "block", sm: "flex" } }}
                        alignItems={"center"}
                        justifyContent={"center"}
                    >
                        <Box
                            display={"flex"}
                            alignItems={"center"}
                            justifyContent={"center"}
                            sx={{ mr: 2, mb: { xs: 2, sm: 0 } }}
                        >
                            <BoxCustomerID>
                                <CustomTitle>Customer ID</CustomTitle>
                            </BoxCustomerID>
                            <BoxValueCustomerID
                                fullWidth
                                value={customerId}
                                onChange={(e: any) => onChangeCustomerId(e)}
                            />
                        </Box>
                        <ContainButtonShort
                            disabled={_.isEmpty(customerId)}
                            onClick={() => handleSubmit()}
                        >
                            Submit
                        </ContainButtonShort>
                    </Box>
                    {(amount && customerId !== "" && isSubmit) ?
                        <Stack>
                            <Typography fontWeight={400} fontSize={20}>
                                Amount
                            </Typography>
                            <Typography
                                fontWeight={700}
                                sx={{ fontSize: { xs: "58px", sm: "84px" } }}
                            >
                                {amount.toLocaleString()}
                            </Typography>
                            <Typography fontWeight={400} fontSize={20}>
                                {amount === "1" ? "Token" : "Tokens"}
                            </Typography>
                        </Stack>
                        : (isSubmit && customerId !== "") &&
                        <Typography fontWeight={500} fontSize={20}>
                            Customer ID not found.
                        </Typography>
                    }
                </Stack>
            </Box>
        </Container >
    );
};

export default CheckBalancePage;
